import script from "./TressPagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./TressPagination.vue?vue&type=script&setup=true&lang=ts"

import "./TressPagination.vue?vue&type=style&index=0&id=015f1ee5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-015f1ee5"]])

export default __exports__